import { WSList } from "@wingspanhq/fe-component-library";
import { InsuranceMonitor } from "@wingspanhq/wingspan-api-sdk";

import { AIValidationWidget } from "../../../components/AIValidationWidget";
import { RequirementContextType } from "../../../types";
import { getInsuranceMonitorValidationItems } from "../configs/helpers/getInsuranceMonitorValidationItems";

interface Props {
  insuranceMonitor: InsuranceMonitor;
  context: RequirementContextType;
}

/**
 * The per-policy validation results for a monitor. v1 rendered the monitor
 * settings' validation jobs grouped per settings coverage; the v3 monitor
 * carries the equivalent results on `jobs`, so no separate coverage read is
 * needed to decide what passed.
 */
export const InsuranceCoverageDetailsWidgetContainer: React.FC<Props> = ({
  insuranceMonitor,
  context
}) => {
  const validationItems = getInsuranceMonitorValidationItems(insuranceMonitor);

  if (!validationItems.length) {
    return null;
  }

  return (
    <WSList gap="S">
      <AIValidationWidget
        contextType={context}
        validationItems={validationItems}
      />
    </WSList>
  );
};
